import RouterView from '@/page/main/DefaultRouterView'


import UnitList from '@/page/storage/unitList'
import RoomList from '@/page/storage/roomList'
import RoomDetail from '@/page/storage/roomDetail'
import SupplierList from '@/page/asset/supplierList'

// 材料基本信息管理
import MaterialList from '@/page/storage/materialList'
// 材料类别管理
import MaterialTypeList from '@/page/storage/materialTypeList'
// 材料入库
import MaterialIn from '@/page/storage/materialIn'
import MaterialInList from '@/page/storage/materialInList'
import MaterialInDetailList from '@/page/storage/materialInDetailList'
// 材料调拨
import MaterialAllot from '@/page/storage/materialAllot'
import MaterialAllotList from '@/page/storage/materialAllotList'
// 使用材料申请
import MaterialUse from '@/page/storage/materialUse'
import MaterialUseOutList from '@/page/storage/materialUseOutList'
import MaterialUseList from '@/page/storage/materialUseList'
import MaterialUseDetailList from '@/page/storage/MaterialUseDetailList'
// 材料退库
import MaterialBack from '@/page/storage/materialBack'
import MaterialBackAllList from '@/page/storage/materialBackAllList'
import MaterialBackList from '@/page/storage/materialBackList'
import MaterialBackDetailList from '@/page/storage/materialBackDetailList'
// 业务性退库
import MaterialBackForce from '@/page/storage/materialBackForce'
import MaterialBackForceList from '@/page/storage/materialBackForceList'
// 材料盘点
import MaterialInventory from '@/page/storage/materialInventory'
import MaterialInventoryList from '@/page/storage/materialInventoryList'
import MaterialInventoryDetailList from '@/page/storage/materialInventoryDetailList'
// 材料月度报表
import MaterialReport from '@/page/storage/reportList'
// 出库单登记
import MaterialOut from '@/page/storage/materialOut'
import MaterialOutList from '@/page/storage/materialOutList'
// 材料使用/领用汇总表
import MaterialUseDetailListByCustomer from '@/page/storage/MaterialUseDetailListByCustomer'


export default {
  path: '/Storage',
  component: RouterView,
  children: [{
      path: 'MaterialUseDetailListByCustomer/:houseId?',
      meta: {
        type: ['storage', 'MaterialUseDetailListByCustomer'],
        title: '材料使用/领用汇总表'
      },
      component: MaterialUseDetailListByCustomer
    }, {
      path: 'MaterialBackAllList/:houseId?',
      meta: {
        type: ['storage', 'materialBackAllList'],
        title: '材料退库单列表'
      },
      component: MaterialBackAllList
    }, {
      path: 'MaterialBackForce/:houseId?',
      meta: {
        type: ['storage', 'materialBackForceList'],
        title: '材料业务性退库'
      },
      component: MaterialBackForce
    },
    {
      path: 'MaterialBackForceList/:houseId?',
      meta: {
        type: ['storage', 'materialBackForceList'],
        title: '材料业务性退库列表'
      },
      component: MaterialBackForceList
    }, {
      path: 'MaterialOut/:houseId?',
      meta: {
        type: ['storage', 'materialOutList'],
        title: '维修/新购出库登记'
      },
      component: MaterialOut
    }, {
      path: 'MaterialOutList/:houseId?',
      meta: {
        type: ['storage', 'materialOutList'],
        title: '维修/新购出库登记列表'
      },
      component: MaterialOutList
    }, {
      path: 'MaterialList',
      meta: {
        type: ['storage', 'storageMaterialList'],
        title: '材料基础资料管理'
      },
      component: MaterialList
    }, {
      path: 'MaterialTypeList',
      meta: {
        type: ['storage', 'materialTypeList'],
        title: '材料类别管理'
      },
      component: MaterialTypeList
    }, {
      path: 'UnitList',
      meta: {
        type: ['storage', 'unitList'],
        title: '计量单位列表'
      },
      component: UnitList
    }, {
      path: 'Room/List',
      meta: {
        type: ['storage', 'roomlist'],
        title: '仓库列表'
      },
      component: RoomList
    }, {
      path: 'Detail/:houseId?',
      meta: {
        type: ['storage', 'realTimeList'],
        title: '实时库存查询'
      },
      component: RoomDetail
    }, {
      path: 'SupplierList/:type',
      meta: {
        type: ['storage', 'storageSupplierList'],
        title: '材料供应商列表'
      },
      component: SupplierList
    }, {
      path: 'MaterialIn/:houseId?',
      meta: {
        type: ['storage', 'materialInList'],
        title: '材料入库'
      },
      component: MaterialIn
    }, {
      path: 'MaterialInList/:houseId?',
      meta: {
        type: ['storage', 'materialInList'],
        title: '材料入库单列表'
      },
      component: MaterialInList
    }, {
      path: 'MaterialInDetailList/:houseId?',
      meta: {
        type: ['storage', 'materialInDetailList'],
        title: '材料入库明细列表'
      },
      component: MaterialInDetailList
    }, {
      path: 'MaterialAllot/:houseId?',
      meta: {
        type: ['storage', 'materialAllotList'],
        title: '材料调拨'
      },
      component: MaterialAllot
    }, {
      path: 'MaterialAllotList/:houseId?',
      meta: {
        type: ['storage', 'materialAllotList'],
        title: '材料调拨单列表'
      },
      component: MaterialAllotList
    }, {
      path: 'MaterialUse/:houseId?',
      meta: {
        type: ['storage', 'materialUseList'],
        title: '领用材料申请'
      },
      component: MaterialUse
    }, {
      path: 'MaterialUseList/:houseId?',
      meta: {
        type: ['storage', 'materialUseList'],
        title: '领用材料申请列表'
      },
      component: MaterialUseList
    }, {
      path: 'MaterialUseOutList/:houseId?',
      meta: {
        type: ['storage', 'materialUseOutList'],
        title: '材料出库单列表'
      },
      component: MaterialUseOutList
    }, {
      path: 'MaterialUseDetailList/:houseId?',
      meta: {
        type: ['storage', 'materialUseDetailList'],
        title: '材料出库明细列表'
      },
      component: MaterialUseDetailList
    }, {
      path: 'MaterialBack/:houseId?',
      meta: {
        type: ['storage', 'materialBackList'],
        title: '材料退库'
      },
      component: MaterialBack
    }, {
      path: 'MaterialBackList/:houseId?',
      meta: {
        type: ['storage', 'materialBackList'],
        title: '材料退库列表'
      },
      component: MaterialBackList
    }, {
      path: 'MaterialBackDetailList/:houseId?',
      meta: {
        type: ['storage', 'materialBackDetailList'],
        title: '材料退库明细列表'
      },
      component: MaterialBackDetailList
    }, {
      path: 'MaterialInventory/:houseId?',
      meta: {
        type: ['storage', 'materialInventoryList'],
        title: '材料盘点'
      },
      component: MaterialInventory
    }, {
      path: 'MaterialInventoryList/:houseId?',
      meta: {
        type: ['storage', 'materialInventoryList'],
        title: '材料盘点列表'
      },
      component: MaterialInventoryList
    }, {
      path: 'MaterialInventoryDetailList/:houseId?',
      meta: {
        type: ['storage', 'materialInventoryDetailList'],
        title: '材料盘存损益明细列表'
      },
      component: MaterialInventoryDetailList
    }, {
      path: 'MaterialReport',
      meta: {
        type: ['storage', 'materialReport'],
        title: '材料月度报表'
      },
      component: MaterialReport
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/storage.js